// ── v1.1 product analytics (PRODUCT_ANALYTICS_ENABLED) — privacy-safe ────────
// Funnel events go to the Plausible script already loaded by index.html (cookie-less, no
// personal data). Event names only, plus a few coarse props; never ids, e-mails, names,
// URLs with query strings, or résumé content. With the flag off, nothing is sent.
import { currentLaunchConfig } from "./launch-config";

export type FunnelEvent =
  | "signup" | "email_verified" | "resume_uploaded" | "first_match_viewed"
  | "job_saved" | "job_applied" | "extension_capture_viewed" | "data_exported";

const ALLOWED_PROP = /^(method|tier|count_band|source)$/;

export function track(event: FunnelEvent, props?: Record<string, string>): void {
  if (!currentLaunchConfig().flags.productAnalytics) return;
  const w = window as unknown as { plausible?: (e: string, o?: { props?: Record<string, string> }) => void };
  if (typeof w.plausible !== "function") return;
  const safe: Record<string, string> = {};
  for (const [k, v] of Object.entries(props ?? {})) if (ALLOWED_PROP.test(k) && v.length <= 40) safe[k] = v;
  try { w.plausible(event, Object.keys(safe).length ? { props: safe } : undefined); } catch { /* never break the app */ }
}

/** Fire an event at most once per browser (e.g. first match viewed). */
export function trackOnce(event: FunnelEvent, props?: Record<string, string>): void {
  if (!currentLaunchConfig().flags.productAnalytics) return;
  const key = `calibre_once_${event}`;
  try { if (localStorage.getItem(key)) return; localStorage.setItem(key, "1"); } catch { /* storage blocked: still send */ }
  track(event, props);
}
